export const pageviewEvent = (page) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics?.page(page);
  }
};

export const retainerIdentify = (name, email, phoneNumber, numberOfRetainers) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics?.track('Retainers Form Submitted',
      {
        name,
        phone: phoneNumber,
        email,
        number_of_sets: numberOfRetainers
      });
  }
};

export const getButtonDetails = (buttonId) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics?.track('Button Clicked',
      {
        btn_id: buttonId,
        btn_location: 'webpage',
        btn_name: 'Get yours now',
        current_page: 'Retainers',
        topic: 'Retainers'
      });
  }
};

export const remainingFill = (data) => {
  if (process.env.NEXT_PUBLIC_SEGMENT_ID) {
    window.analytics?.track('Retainers Form Dropped Off',
      {
        missing_fields: data
      });
  }
};
